/**
 * @todo will be partially deprecated in favor of native container query implementations
 */
(function (context, namedBreakpoints) {
    function replaceSpecialTokens(code) {
        const replacements = {
            ' lt ': ' < ',
            ' lte ': ' <= ',
            ' eq ': ' == ',
            ' neq ': ' != ',
            ' gte ': ' >= ',
            ' gt ': ' > ',
            ' and ': ' && ',
            ' or ': ' || ',
        };
        Object.getOwnPropertyNames(replacements).forEach(token => {
            code = code.replaceAll(token, replacements[token]);
        });
        return code;
    }

    async function parse(node) {
        let target;
        let code;
        if (node instanceof HTMLScriptElement) {
            code = node.textContent;
            if (node.dataset.target) {
                target = document.getElementById(node.dataset.target);
            } else {
                target = node.parentElement;
            }
        } else {
            target = node;
            code = node.getAttribute('data-cq').toString();
            code = replaceSpecialTokens(code);
        }
        if (target && code) {
            function attr(assertion, attrName, thenValue, elseValue) {
                const value = assertion ? thenValue : elseValue;
                if (value === null || value === undefined) {
                    target.removeAttribute(attrName);
                } else {
                    target.setAttribute(attrName, value);
                }
                return true;
            }
            function toggleClass(assertion, className) {
                target.classList[assertion ? 'add' : 'remove'](className);
                return true;
            }
            function breakpoints() {
                const width = target.parentElement.offsetWidth;
                const cl = target.classList;
                const matches = {};
                Object.getOwnPropertyNames(namedBreakpoints).forEach(breakpointName => {
                    matches[breakpointName] = width >= namedBreakpoints[breakpointName].numberValue;
                });
                Object.getOwnPropertyNames(namedBreakpoints).forEach(breakpointName => {
                    if (matches[breakpointName]) {
                        cl.add(`container-${breakpointName}-up`);
                        cl.remove(`container-until-${breakpointName}`);
                    } else {
                        cl.remove(`container-${breakpointName}-up`);
                        cl.add(`container-until-${breakpointName}`);
                    }
                });
                return true;
            }
            let callback;
            eval(`callback = function(width, height) {
                ${Object.getOwnPropertyNames(namedBreakpoints).map(breakpointName => `
                const ${breakpointName} = ${namedBreakpoints[breakpointName].numberValue};
                `).join('\n')}
                ${code}
            }`);
            target['containerQueryCallback'] = callback;
            new ResizeObserver((entries) => {
                callback(entries[0].target.offsetWidth, entries[0].target.offsetHeight);
            }).observe(target.parentElement);
            callback(target.parentElement.offsetWidth, target.parentElement.offsetHeight);
        }
        return true;
    }

    // this is taken from responsive-image.js - we could try to streamline some things here
    const addPolyfill = document.createElement('source')['width'] === undefined;

    function resizeContainerImage(picture) {
        const sources = Array.from(picture.querySelectorAll('source'));
        sources.forEach(source => source.media = 'not all');
        const width = picture.parentElement.offsetWidth;
        const height = picture.parentElement.offsetHeight;
        let validSource = null;
        for (let source of sources) {
            if (typeof source['containerImageCallback'] === 'function') {
                if (source['containerImageCallback'](width, height)) {
                    validSource = source;
                    break;
                }
            } else {
                // fallback image
                validSource = source;
                break;
            }
        }
        if (validSource) {
            validSource.media = 'all';
            if (addPolyfill) {
                const img = picture.querySelector('img');
                let width = img.dataset.originalWidth;
                let height = img.dataset.originalHeight;
                if (validSource.getAttribute('width')) {
                    width = validSource.getAttribute('width');
                }
                if (validSource.getAttribute('height')) {
                    height = validSource.getAttribute('height');
                }
                img.width = width;
                img.height = height;
            }
        }
    }

    const containerImageResizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
            Array.from(entry.target.querySelectorAll('picture[data-container-image]')).forEach(resizeContainerImage)
        })
    });

    // @see https://ticket.pixelpoint.at/issues/33240
    // regular browsers do it with innerHTML but safari on iOS is a different story
    let accessor;
    const testNode = document.createElement('div');
    testNode.innerHTML = '<noscript><span></span></noscript>';
    const assertionNode = testNode.querySelector('noscript');
    if (assertionNode.innerHTML.indexOf('<') !== -1) {
        accessor = node => node.innerHTML;
        accessProperty = 'innerHTML';
    } else if (assertionNode.innerText.indexOf('<') !== -1) {
        accessor = node => node.innerText;
    } else if (assertionNode.textContent.indexOf('<') !== -1) {
        accessor = node => node.textContent;
    }
    /**
     * @param {HTMLElement} noscript
     * @return {?HTMLPictureElement}
     */
    function getPictureFromNoscriptElement(noscript) {
        return new DOMParser().parseFromString(accessor(noscript), 'text/html').querySelector('picture');
    }

    let processed = false;

    function process() {
        processed = true;
        Promise.all([].concat(
            Array.from(context.querySelectorAll(':is(script[type="container-query"],*[data-cq]):not([data-cq-parsed])')).map(node => {
                return new Promise(resolve => {
                    node.setAttribute('data-cq-parsed', 'true');
                    let target;
                    if (node instanceof HTMLScriptElement) {
                        if (node.dataset.target) {
                            target = document.getElementById(node.dataset.target);
                        } else {
                            target = node.parentElement;
                        }
                    } else {
                        target = node;
                    }
                    if ('containerQueryCallback' in target) {
                        resolve();
                    } else {
                        parse(node).then(resolve);
                    }
                });
            }),
            /**
             * we react to inserted picture tags as well to react to node cloning
             */
            Array.from(context.querySelectorAll(':is(noscript[data-container-image],picture[data-container-image]):not([data-cq-image-parsed])')).map(node => {
                return new Promise(resolve => {
                    node.setAttribute('data-cq-image-parsed', true);
                    let picture;
                    if (node instanceof HTMLPictureElement) {
                        if ('containerImageCallback' in node) {
                            return resolve();
                        }
                        picture = node;
                    } else {
                        picture = getPictureFromNoscriptElement(node);
                        picture.setAttribute('data-container-image', 'true');
                    }
                    const img = picture.querySelector('img');
                    img.dataset.originalWidth = `${img.width || img.naturalWidth || ''}`;
                    img.dataset.originalHeight = `${img.height || img.naturalHeight || ''}`;
                    const sources = Array.from(picture.querySelectorAll('source'));
                    sources.forEach(source => {
                        source.media = 'not all';
                        let code = source.dataset.size ?? '';
                        code = replaceSpecialTokens(code);
                        let callback = null;
                        if (code !== '') {
                            eval(`callback = function(width, height) {
                                ${Object.getOwnPropertyNames(namedBreakpoints).map(breakpointName => `const ${breakpointName} = ${namedBreakpoints[breakpointName].numberValue};`).join('\n')}
                                return ${code};
                            }`);
                        }
                        source['containerImageCallback'] = callback;
                    });
                    if (!(node instanceof HTMLPictureElement)) {
                        node.parentElement.replaceChild(picture, node);
                    }
                    resizeContainerImage(picture);
                    containerImageResizeObserver.observe(picture.parentElement);
                    resolve();
                });
            })
        ));
    }
    const observer = new MutationObserver(process);
    observer.observe(context, {
        childList: true,
        subtree: true,
    });
    if (processed === false) {
        process();
    }
})(document, window['namedBreakpoints'] ?? {});
